/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react';
import { filesAPI } from 'src/api/modules/files';
import { sessionsAPI } from 'src/api/modules/sessions';
import { Check, CancelScheduleSend } from '@material-ui/icons';
import { Grid, Button, IconButton, Avatar } from '@material-ui/core';
import { UploadFileMinos, download } from 'src/pages/Files/UpaloadFileMinos';
import PublishSendSessionModal from '../PublishSendSession/PublishSendSessionModal';
import CustomButton from 'src/common/components/CustomButton';
import notice from 'src/common/components/Notice';
import './styles/_convene.scss';
import { Fragment } from 'react';

const Convene = ({ session, canEdit, tab }) => {
	const [fileBase64, setFileBase64] = useState();
	const [loaderUpA, setLoaderUpA] = useState(false);
	const [selectFile, setSelectFile] = useState(null);
	const { user } = useSelector((state) => state.auth);
	const [loaderDownA, setLoaderDownA] = useState(false);
	const [loaderGenerateA, setLoaderGenerateA] = useState(false);
	const [btnPublishSession, setBtnPublishSession] = useState(false);
	const [currentFile, setCurrentFile] = useState({
		idEntidad: session.id,
		tipo: 'A',
		entidad: 'SESION',
		ruta: 'Convocatoria/' + session.id + '/',
		title: 'Convocatoria',
		nombre: '',
	});

	useEffect(() => {
		if (tab === 2) getFiles();
	}, [tab]);

	const getFiles = () => {
		filesAPI
			.get('SESION', session.id, false, 'C')
			.then((response) => {
				// response = response.filter((e) => {
				// 	return e.tipo === 'A' && e.ruta.charAt(0) === 'C';
				// });
				let addName = {
					...currentFile,
					nombre:
						response.length > 0 ? response[response.length - 1].nombre : '',
				};
				setCurrentFile(addName);
				if (!fileBase64 && addName?.nombre !== '') getFileConv(addName?.nombre);
			})
			.catch((e) => {
				notice('Ocurrio un error', 'error');
			});
	};

	const getFileConv = (fileName) => {
		download(
			currentFile.ruta,
			fileName,
			user.nombre + ' ' + user.apellidoPaterno + ' ' + user.apellidoMaterno,
			null,
			'Convocatoria',
			'Convocatoria',
			setFileBase64
		);
	};
	const generateAnnouncement = () => {
		setLoaderGenerateA(true);
		sessionsAPI
			.generateAnnouncement(
				session.id,
				session.lugar,
				session.aviso,
				session.direccion
			)
			.then((response) => {
				let blob = response;
				let da = document.createElement('a');
				da.href = URL.createObjectURL(blob);
				da.setAttribute('download', 'OrdenDia.docx');
				da.click();
				URL.revokeObjectURL(da.href);
				document.body.removeChild(document.body.lastChild);
				setLoaderGenerateA(false);
				notice('Se ha generado el archivo de convocatoria con exito', 'success');
			})
			.catch(() => {
				notice('Ocurrió un problema al generar convocatoria');
			});
	};

	const getId = () => {
		if (currentFile.idEntidad === undefined) {
			currentFile.idEntidad = 'undefined';
			return 'BtnuploadMinos' + currentFile?.idEntidad?.toString() + 'Convocatoria';
		}
		return 'BtnuploadMinos' + currentFile.idEntidad.toString() + 'Convocatoria';
	};

	const getBase64 = (File) => {
		setSelectFile(File.fileName);
		return new Promise((resolve) => {
			let reader = new FileReader();
			reader.readAsDataURL(File.file);
			reader.onload = () => {
				const base64String = reader.result
					.replace('data:', '')
					.replace(/^.+,/, '');
				resolve(base64String);
				let file64 = base64String;
				setFileBase64(file64);
			};
		});
	};

	return (
		<div
			className="card"
			style={{
				height: '79%',
				padding: '30px 0px 30px 0px',
			}}
		>
			<Grid
				container
				spacing={1}
				style={{
					justifyContent: 'center',
				}}
			>
				{canEdit && (
					<Fragment>
						<Grid
							item
							xs={2}
							lg={2}
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<CustomButton
								mainText="Generar Convocatoria"
								onClick={() => {
									generateAnnouncement();
								}}
								loading={loaderGenerateA}
							/>
						</Grid>
						<Grid
							item
							xs={2}
							lg={2}
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<hr className="hrLinea " style={{ width: '85%' }} />
						</Grid>
						<Grid
							item
							xs={2}
							lg={2}
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<UploadFileMinos
								control={
									<Button
										name="nombreFile"
										id={getId()}
										style={{
											background: '#cbe5fb',
											color: '#0080f9',
										}}
									>
										Adjuntar Convocatoria
										{loaderUpA && (
											<span
												style={{
													paddingLeft: '15px',
												}}
												className="ml-3 spinner spinner-white"
											></span>
										)}
									</Button>
								}
								idEntidad={currentFile.idEntidad}
								tipo={currentFile.tipo}
								entidad={currentFile.entidad}
								ruta={currentFile.ruta}
								title={currentFile.title}
								nombre={currentFile.nombre}
								setOpen={setLoaderUpA}
								onUploaded={(data, file) => {
									getBase64(file);
									getFiles();
								}}
								acceptOnly={[
									'application/pdf',
									'application/msword',
									'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
								]}
							/>
						</Grid>
					</Fragment>
				)}
				{currentFile.nombre !== '' && (
					<>
						<Grid
							item
							xs={2}
							lg={2}
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<hr
								className={canEdit ? 'hrLinea ' : 'd-none'}
								style={{ width: '85%' }}
							/>
						</Grid>
						<Grid
							item
							xs={2}
							lg={2}
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<CustomButton
								key={'btnDownConvene'}
								mainText="Descargar Convocatoria"
								onClick={() =>
									download(
										currentFile.ruta,
										currentFile.nombre,
										user.nombre +
											' ' +
											user.apellidoPaterno +
											' ' +
											user.apellidoMaterno,
										setLoaderDownA,
										'botón Descargar Convocatoria'
									)
								}
								loading={loaderDownA}
							/>
						</Grid>
					</>
				)}
			</Grid>
			{currentFile.nombre !== '' && (
				<Grid
					container
					style={{
						justifyContent: 'center',
					}}
				>
					{canEdit && (
						<IconButton
							onClick={() => {
								setBtnPublishSession(true);
							}}
						>
							<Avatar
								style={{
									backgroundColor: '#cbe5fb',
									color: '#0080F9',
									height: '70px',
									width: '70px',
									fontSize: '12px',
								}}
							>
								<Grid container>
									Publicar Sesión
									<Grid item xs={12}>
										{session.publicada === 'P' ? (
											<Check />
										) : (
											<CancelScheduleSend />
										)}
									</Grid>
								</Grid>
							</Avatar>
						</IconButton>
					)}
				</Grid>
			)}
			<PublishSendSessionModal
				open={btnPublishSession}
				setOpen={setBtnPublishSession}
				idSession={session.id}
				file={fileBase64}
				nameFile={selectFile || currentFile?.nombre || 'No-name'}
				organID={session.organoId}
				dataSession={session}
			/>
		</div>
	);
};

export default Convene;
